import styled from 'styled-components';

export const CombineModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;
export const CombineModalContent = styled.div`
    align-items: start;
    display: flex;
    flex-direction: column;
    gap: 16px;
    backdrop-filter: blur(10px);
    max-width: 500px;
    width: 90%;   
`;